import React from 'react';
import { withRouter } from 'Components/withRouter';
import styles from './ChangePasswordForm.module.css';

class ChangePasswordForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            existingPassword: '',
            newPassword: '',
            confirmPassword: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(document.getElementById('changePasswordForm'));

        if(formData.get("newPassword") !== formData.get("confirmPassword")) {
            alert('Passwords do not match!');
            return false;
        }

        this.props.onFormSubmit(formData);
    }

    handleCancel(event) {
        this.props.router.navigate(-1);
    }

    render() {
        return (
            <form id="changePasswordForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                        <div className="form-group form-group-sm">
                            <label htmlFor="inputExistingPassword">*Current Password</label>
                            <input id="inputExistingPassword" name="existingPassword" type="password" className="form-control" required value={this.state.existingPassword} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label htmlFor="inputNewPassword">*New Password</label>
                            <input id="inputNewPassword" name="newPassword" type="password" className="form-control" required value={this.state.newPassword} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label htmlFor="inputConfirmPassword">*Confirm Password</label>
                            <input id="inputConfirmPassword" name="confirmPassword" type="password" className="form-control" required value={this.state.confirmPassword} onChange={this.handleChange} />
                        </div>
                        <button type="submit" className="btn btn-default btn-dl-green">CHANGE</button>
                        <button type="button" className="btn btn-dfault btn-dl-green" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
            );
    };
}

export default withRouter(ChangePasswordForm);